import { useMemo } from 'react';

import objectToQueryString from '../../helpers/url/objectToQueryString';
import GpsCoordinate from '../types/GpsCoordinate';

const useGoogleMapsUrl = (gps: GpsCoordinate, zoom: number) => {
    return useMemo(() => {
        const base = 'https://www.google.com/maps/search/?api=1&';
        const params: Record<string, string> = {
            query: `${gps.lat},${gps.long}`,
            center: `${gps.lat},${gps.long}`,
            zoom: zoom.toString(),
        };

        return base + objectToQueryString(params);
    }, [gps.lat, gps.long, zoom]);
};

export default useGoogleMapsUrl;
